<template>
  <v-layout
    id="userRegistration"
    row
    wrap
    justify-center
  >
    <v-flex
      xs12
      sm8
      md6
    >
      <v-card class="elevation-12 register">
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>
            {{ $t('message.register_form_title') }}
          </v-toolbar-title>
          <v-spacer />
          <img src="../../../public/cow.svg">
        </v-toolbar>
        <v-card-text>
          <v-form
            novalidate
            @submit.prevent="validateUser"
          >
            <v-text-field
              ref="firstName"
              v-model="user.first_name"
              required
              name="first_name"
              :label="($t('message.first_name') + ' *')"
              type="text"
              :error-messages="validationErrors['first_name']"
            />
            <v-text-field
              v-model="user.insertion"
              name="insertion"
              :label="$t('message.insertion')"
              type="text"
            />
            <v-text-field
              v-model="user.last_name"
              required
              name="last_name"
              :label="($t('message.last_name') + ' *')"
              type="text"
              :error-messages="validationErrors['last_name']"
            />
            <v-radio-group
              v-model="user.sex"
              :label="$t('message.sex')"
              :items="sexes"
            >
              <v-radio
                v-for="(item, index) in sexes"
                :key="index"
                :label="item.title"
                :value="item.id"
              />
            </v-radio-group>
            <!-- <v-menu
                  ref='menu'
                  :close-on-content-click='false'
                  v-model='menu'
                  :nudge-right='40'
                  lazy
                  transition='scale-transition'
                  offset-y
                  full-width
                  min-width='290px'>
                  <v-text-field
                      :label='$t("message.birth_date")'
                      slot='activator'
                      v-model='displayBirthDate'
                      prepend-icon='event'
                      required
                      hint='dd-mm-yyyy'
                      persistent-hint
                      readonly
                  >
                  </v-text-field>
                  <v-date-picker
                      ref='picker'
                      v-model='user.birth_date'
                      @change='saveDate'
                      locale='nl-nl'>
                  </v-date-picker>
          </v-menu>-->
            <!-- <v-text-field
            v-model="user.birth_date"
            name="birth_date"
            :label="$t('message.birth_date')"
            mask="##/##/####"
            :hint="$t('message.birth_date_hint')"
            persistent-hint
          ></v-text-field> -->
            <v-text-field
              v-model="user.phone"
              name="phone"
              :label="$t('message.phone')"
              type="text"
            />
            <v-text-field
              v-model="user.email"
              name="login"
              :label="($t('message.email') + ' *')"
              type="text"
              :error-messages="validationErrors['email']"
            />
            <v-text-field
              :value="user_subscriptions[user.subscription]"
              :label="$t('message.user_subscription')"
              :error-messages="validationErrors['subscription']"
              readonly
            />
            <v-select
              v-model="user.role"
              :items="userRoles"
              item-value="id"
              item-text="title"
              :label="($t('message.select_user_role') + ' *')"
              :error-messages="validationErrors['role']"
            />
            <v-text-field
              v-model="user.password"
              name="password"
              autocomplete="new-password"
              :label="($t('message.new_password') + ' *')"
              type="password"
              :error-messages="validationErrors['password']"
            />
            <v-text-field
              v-model="user.confirm_password"
              name="confirm_password"
              :label="($t('message.confirm_password') + ' *')"
              type="password"
              :error-messages="validationErrors['confirm_password']"
            />
            <v-checkbox
              v-model="agree_with_privacy_statement"
              :error-messages="validationErrors['agree_with_privacy_statement']"
            >
              <template v-slot:label>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <span v-html="agree_with_terms" />
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="user.receive_newsletter"
              :label="$t('message.receive_newsletter')"
              hide-details
            />
            <v-container grid-list-xl>
              <v-layout
                row
                justify-space-between
              >
                <v-flex
                  xs8
                  sm7
                  md8
                >
                  <v-text-field
                    v-if="user.role && user.role != 'student'"
                    v-model="user.companyTankNumber"
                    name="companyTankNumber"
                    :label="$t('message.company_tank_number') + ' *'"
                    type="text"
                    :disabled="company != false"
                  />
                </v-flex>
                <v-flex
                  xs4
                  sm5
                  md4
                >
                  <v-dialog
                    v-if="user.role && user.role == 'owner' && !company"
                    v-model="showCompanyRegistrationDialog"
                    persistent
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="secondary"
                        dark
                        v-on="on"
                      >
                        {{ $t('message.create_company') }}
                      </v-btn>
                    </template>
                    <company @close="showCompanyRegistrationDialog = false" />
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            flat
            :to="{ name: 'login' }"
          >
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            @click="validateUser"
          >
            {{ $t('message.register_button') }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-snackbar
        v-model="showError"
        color="error"
        :multi-line="true"
      >
        {{ $t('message.general_form_error') }}
        <v-btn
          dark
          flat
          @click="showError = false"
        >
          {{ $t('message.close') }}
        </v-btn>
      </v-snackbar>
      <v-snackbar
        v-model="showServiceError"
        color="error"
        :multi-line="true"
      >
        {{ serviceError }}
        <v-btn
          dark
          flat
          @click="showError = false"
        >
          {{ $t('message.close') }}
        </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required, email, sameAs } from 'vuelidate/lib/validators'

import { mapState } from 'vuex'
import Company from './Company'
export default {
  components: { Company },
  mixins: [validationMixin],
  data: (vm) => ({
    user_roles: [
      { id: 'owner', title: vm.$t('message.user_role_owner') },
      { id: 'collaborator', title: vm.$t('message.user_role_collaborator') },
      { id: 'consultant', title: vm.$t('message.user_role_consultant') },
      { id: 'student', title: vm.$t('message.user_role_student') },
    ],
    user_subscriptions: {
      standard: vm.$t('message.user_subscription_standard'),
      extensive: vm.$t('message.user_subscription_extensive'),
      watch: vm.$t('message.user_subscription_watch'),
      student: vm.$t('message.user_subscription_student'),
    },
    sexes: [
      { id: 'f', title: vm.$t('message.sex_female') },
      { id: 'm', title: vm.$t('message.sex_male') },
      { id: '', title: vm.$t('message.sex_undefined') },
    ],
    privacyStatementLink: vm.$t('message.agree_with_privacy_statement'),
    user: {
      first_name: '',
      insertion: '',
      last_name: '',
      sex: '',
      birth_date: '',
      phone: '',
      email: '',
      role: '',
      subscription: '',
      password: '',
      confirm_password: '',
      receive_newsletter: false,
      companyTankNumber: '',
    },
    agree_with_privacy_statement: false,
    serviceError: '',
    showError: false,
    showServiceError: false,
    menu: false,
    showCompanyRegistrationDialog: false,
    company: false,
    agree_with_terms: vm.$t('message.agree_with_privacy_statement') + ' *',
  }),
  computed: {
    displayBirthDate() {
      return this.formatDate(this.user.birth_date)
    },
    validationErrors() {
      const v = this.$v.user
      function errorsFromArray(fieldName, validations) {
        return validations
          .filter((obj) => {
            return !v[fieldName][obj.key]
          })
          .map((o) => o.message)
      }

      const errors = {
        first_name: this.$t('message.required_field'),
        last_name: this.$t('message.required_field'),
        email: errorsFromArray('email', [
          { key: 'email', message: this.$t('message.invalid_email') },
          { key: 'required', message: this.$t('message.required_field') },
        ]),
        role: this.$t('message.required_field'),
        subscription: this.$t('message.required_field'),
        password: this.$t('message.required_field'),
        confirm_password: errorsFromArray('confirm_password', [
          { key: 'sameAs', message: this.$t('message.passwords_mismatch') },
          { key: 'required', message: this.$t('message.required_field') },
        ]),
        agree_with_privacy_statement: this.$t('message.agreement_required'),
      }

      const newErrors = {}
      Object.keys(errors).forEach((fieldName) => {
        if (fieldName == 'agree_with_privacy_statement') {
          newErrors[fieldName] =
            this.$v.agree_with_privacy_statement.$dirty &&
            this.$v.agree_with_privacy_statement.$invalid
              ? errors[fieldName]
              : undefined
        } else {
          newErrors[fieldName] =
            this.$v.user[fieldName].$dirty && this.$v.user[fieldName].$invalid
              ? errors[fieldName]
              : undefined
        }
      })

      return newErrors
    },
    userRoles() {
      let rolesIds = []
      switch (this.user.subscription) {
      case 'student': //information platform
        return this.user_roles
        break
      case 'standard': //discussion platform
        rolesIds = ['owner', 'collaborator']
        break
      case 'extensive': //project geef ze de vijf
        rolesIds = ['owner', 'collaborator']
        break
      case 'watch': //platform for erfbetreders
        rolesIds = ['consultant', 'collaborator']
        break
      }
      return this.user_roles.filter((role) => rolesIds.includes(role.id))
    },
  },
  created() {
    // this.agree_with_terms = this.$t('message.agree_with_privacy_statement') + ' *'
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'registrationError') {
        this.serviceError = mutation.payload.message
        this.showServiceError = true
      } else if (mutation.type === 'onCompanyRegistered') {
        this.user.companyTankNumber = mutation.payload.tankNumber
        this.company = mutation.payload
        this.showCompanyRegistrationDialog = false
      }
    })
  },
  mounted() {
    if (this.$route.params.subscription)
      this.user.subscription = this.$route.params.subscription
    this.$refs.firstName.focus()
  },
  methods: {
    saveDate(date) {
      this.$refs.menu.save(date)
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return day !== undefined ? `${day}-${month}-${year}` : `${month}-${year}`
    },
    validateUser() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch('registerUser', this.user)
      } else {
        this.showError = true
      }
    },
  },
  validations: {
    user: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      role: {
        required,
      },
      subscription: {
        required,
      },
      password: {
        required,
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs('password'),
      },
      email: {
        required,
        email,
      },
    },
    agree_with_privacy_statement: {
      required,
    },
  },
}
</script>

<style>
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100% !important;
}
.v-dialog {
  margin: 0 !important;
}
</style>
